<template>
<body class="text-center centrarBody">
  <div>
    <h1>Registro a plataforma de acceso a clientes</h1>
    <v-form v-model="formularioValido1" v-if="controladorPaso1">
      <v-row>
        <!--v-col cols="12">
          <h5>Registro para usuario nuevo</h5>
        </v-col-->
        <v-col cols="12">
          <h6>(1/3) Ingrese su RFC</h6>
        </v-col>
        <v-col cols="12">
          <v-row align="center" justify="start" class="reduce-down">
            <v-col cols="12" md="2" lg="2">
              <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">RFC<b style="color: #5DC00A"> *</b></p>
            </v-col>
            <v-col cols="12" md="10" lg="10">
              <v-text-field
                v-model="rfc"
                :rules="[nameRules.campoVacio, nameRules.rfcValido]"
                outlined class="big-input"
                dense hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <my-captcha :callSuccess="captchaOk2" color="green" mode="math" resolve="text" style="margin: auto;" :key="rerender"></my-captcha>
        </v-col>
         <v-col cols="12" v-if="captchaerror">
            <v-alert type="error">
              Debes completar la operación para continuar
            </v-alert>
        </v-col>
        <v-col cols="12">
          <v-btn
            @click="btnBuscarCliente"
            color="#008230"
            class="white--text btn-new"
            block
            x-large
            :disabled="!formularioValido1"
          >Buscar RFC</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-form v-model="formularioValido2" v-if="controladorPaso2">
      <v-row>
        <v-col cols="12">
          <h6>(2/3) Ingrese código que le fue enviado</h6>
        </v-col>
        <v-col cols="12">
          <v-row align="center" justify="start" class="reduce-down">
            <v-col cols="12" md="3" lg="3">
              <p class="text-start title font-weight-bold mb-5" style="font-size:1.02rem !important;line-height: 1.2rem;">Código de verificación<b style="color: #5DC00A"> *</b></p>
            </v-col>
            <v-col cols="12" md="9" lg="9">
              <v-text-field
                v-model="codigo"
                :rules="[nameRules.campoVacio, nameRules.codigoMayor5]"
                @keypress="isNumber($event)"
                outlined dense
                hide-details="auto"
                counter="5"
                class="big-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-btn
            @click="validarCuenta(codigo)"
            color="#008230"
            class="white--text btn-new"
            block
            x-large
            :disabled="!formularioValido2"
          >Verificar</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-form v-model="formularioValido3" v-if="controladorPaso3">
      <v-row>
        <v-col cols="12">
          <h6>(3/3) Cuenta validada correctamente. Escriba una contraseña</h6>
        </v-col>
        <v-col cols="12">
          <v-row align="center" justify="start" class="reduce-down">
            <v-col cols="12" md="3" lg="3">
              <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">Contraseña<b style="color: #5DC00A"> *</b></p>
            </v-col>
            <v-col cols="12" md="9" lg="9">
              <v-text-field
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[nameRules.campoVacio, nameRules.contrasenaValida]"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                v-model="contrasena"
                class="big-input"
                outlined dense hide-details="auto"
                hint="La contraseña debe contar con entre 8 y 16 caracteres, 1 letra mayúscula, 1 letra minúscula y 1 número. No permite signos."
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row align="center" justify="start" class="reduce-down">
            <v-col cols="12" md="3" lg="3">
              <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">Confirmar contraseña<b style="color: #5DC00A"> *</b></p>
            </v-col>
            <v-col cols="12" md="9" lg="9">
              <v-text-field
                :rules="[nameRules.campoVacio, nameRules.confirmacionContrasena]"
                :type="false ? 'text' : 'password'"
                v-model="contrasena2"
                class="big-input"
                outlined dense hide-details="auto"
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-btn
            :disabled="!formularioValido3"
            color="#008230"
            class="white--text btn-new"
            block
            x-large
            @click="setContrasena(contrasena)"
          >Registrarse</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
  <v-row justify="center">
    <v-dialog v-model="dialogRegistroContenido.visible" persistent max-width="340">
      <v-card>
        <v-card-title class="headline">{{dialogRegistroContenido.titulo}}</v-card-title>
        <v-card-text><p v-html="dialogRegistroContenido.mensaje"></p></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" @click="cerrarDialog()">No</v-btn>
          <v-btn
            v-if="!dialogRegistroContenido.error"
            color="#008230"
            class="white--text"
            @click="crearCuenta(rfc)"
          >Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <div>
    <LoaderDialog></LoaderDialog>
  </div>
</body>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderDialog from "@/components/LoaderDialog.vue";
import myCaptcha from 'vue-captcha';

export default {
  name: "Registro",
  components: {
    LoaderDialog,
    'my-captcha': myCaptcha,
  },
  computed: {
    ...mapState(["dialogRegistroContenido", "controladorPaso1", "controladorPaso2", "controladorPaso3"])
  },
  mounted: function() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });	
  },
  data() {
    return {
      rerender: 0,
      show1: false,
      rfc: "",
      contrasena: "",
      contrasena2: "",
      codigo: "",
      formularioValido1: false,
      formularioValido2: false,
      formularioValido3: false,
      captcha: false,
      captchaerror: false,
      nameRules: {
        campoVacio: v => !!v || "Campo requerido",
        rfcValido: v =>
          /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/.test(
            v
          ) || "Ingrese un RFC valido",
        codigoMayor5: v =>
          v.length == 5 || "El código debe ser igual a 5 dígitos",
        contrasenaValida: v =>
          /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/.test(v) ||
          "La contraseña no cumple con todas las características: tener entre 8 y 16 caracteres, 1 letra mayúscula, 1 letra minúscula y 1 número",
        confirmacionContrasena: v =>
          v == this.contrasena || "Las contrasenas no coinciden"
      }
    };
  },
  watch: {
    'dialogRegistroContenido.visible'() {
      this.switchDialogoChat();
    }
  },
  methods: {
    ...mapActions([
      "buscarCliente",
      "crearCuenta",
      "validarCuenta",
      "setContrasena"
    ]),
    switchDialogoChat() {
      var chat = document.getElementById('calixta-badge');
      chat.style.display = (chat.style.display == 'block') ? 'none' : 'block';
    },
    btnBuscarCliente(){
      if(this.captcha){
        this.$store.dispatch("buscarCliente", this.rfc)
        .then(() => {
          this.forceRerender();
        });
      }else{
        this.captchaerror = true;
      }
    },
    forceRerender(){
      this.rerender += 1;
      this.captcha = false;
    },
    captchaOk2 () {
	    this.captcha = true;
	    this.captchaerror = false;
	  },
    cerrarDialog() {
      var r = { visible: false };
      this.$store.commit("setContenidoDialogRegistro", r);
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.centrarBody {
  padding-left: 10%;
  padding-right: 10%;
  margin-bottom: 50px;
}

@media screen and (max-width: 585px) {
  .centrarBody {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
